
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translater'
})

export class TranslateMessagePipe implements PipeTransform {

  private readonly errorMap: { [key: string]: string } = {
   // NotAuthorizedException
  'Incorrect username or password.': 'Usuário ou senha incorretos',
  'User is disabled': 'Usuário desativado',
  
  // UserNotFoundException
  'User does not exist.': 'Usuário não encontrado',
  'User does not exist': 'Usuário não encontrado', 

  // UserNotConfirmedException
  'User is not confirmed.': 'Usuário não confirmado',
  'User is not confirmed': 'Usuário não confirmado',

  // PasswordResetRequiredException
  'Password reset required for the user': 'É necessário redefinir a senha',

  // TooManyFailedAttemptsException
  'Attempt limit exceeded, please try after some time.': 'Muitas tentativas falharam. Tente novamente mais tarde',

  // LimitExceededException
  'Attempt limit exceeded, please try again later.': 'Limite de tentativas excedido. Tente novamente mais tarde',

  // InvalidParameterException
  'Invalid parameter': 'Parâmetro inválido',
  'Invalid parameters': 'Parâmetros inválidos',

  // ResourceNotFoundException
  'Resource not found': 'Recurso não encontrado',

  // UserAlreadyExistsException (em signup, mas pode aparecer no login se tiver lógica combinada)
  'User already exists': 'Este e-mail já está em uso',

  // CodeMismatchException
  'Invalid verification code provided, please try again.': 'Código de verificação inválido',

  // ExpiredCodeException
  'Verification code expired': 'Código de verificação expirado',

  // Network/client-side errors (não são do Cognito diretamente, mas acontecem com frequência)
  'Network error': 'Erro de rede. Verifique sua conexão',
  'Network Error': 'Erro de rede. Verifique sua conexão',

  // Erro genérico como fallback
  'An unknown error occurred': 'Ocorreu um erro desconhecido',
 'Unauthorized': 'Você não tem permissão',
  };

  transform(value: string): string {
    return this.errorMap[value] || value;
  }

}